<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j3lND8/tc-custom/9781398452244.jpg?1728169228835" alt="This image is the cover for the book Hay Before the Bookshops or the Beeman’s Family"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hay Before the Bookshops or the Beeman’s Family
      </h1>
      <p class="bookDescription body article font2">
        <p>Much as we all love Hay-on-Wye’s bookshops, what was life like in Hay before they arrived? Bridget Ashton, a well-respected local historian, lived here as a child. In this compelling account, she sets out to recall, from the perspective of her girlhood self, what Hay was like in the 1940s and ’50s – with trains, a half-ruined castle, and a cinema (we all know what happened to that). ‘The Beeman’s family’ lived in Market Street, off Castle Square. How did they come to be here? What was family life like in those frugal times? This is the framework for a profound evocation of rural childhood in the post-war years.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bridget Ashton
      </h2>
      
      <p class="authorDescription body article">Bridget was born in a thatched cottage to a beekeeper father and nature-loving mother.  She grew up in the Welsh border town of Hay in the frugal post-World War ll years.  While campaigning against nuclear power stations in rural Northumberland, UK, she and her American husband raised four children.  In recent years, she has written local history books, been a teacher of English language to new citizens, promoted green energy schemes and studied ancient woodlands. She is a septuagenarian who can’t be stopped</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?700b8c98